export default function PHP_date_create() {
  return (
    <div>
      <h1>PHP_date_create</h1>
    </div>
  );
}
